// extracted by css-extract-rspack-plugin
export default {"cls1":"FilterPanel-cls1_rFa","cls2":"FilterPanel-cls2_dM_ FilterPanel-cls1_rFa","mobileLayout":"FilterPanel-mobileLayout_-LE"};